"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
exports.styles = {
  global: {
    body: {
      fontFamily: 'body',
      color: 'black'
    }
  }
};